import { createReducer, on } from '@ngrx/store';
import { addUserModels, loadUserModels } from '../actions/loggedin-user.actions';


export const loggedinUserFeatureKey = 'loggedinUser';

export interface State {

}

export const initialState: State = {

};


export const loggedinUserReducer = createReducer(
  initialState,
  on(loadUserModels, (state, { LoggedInUser }) => ({
   LoggedInUser: LoggedInUser})),
 on(addUserModels, (state, { LoggedInUser }) => ({
   LoggedInUser: LoggedInUser})
 ));

